import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { Link, useParams } from 'react-router-dom'

import { Card } from '../../components/other/card/card'
import DomainInfoEdit from '../../components/domains/DomainInfoEdit'
import DomainXpathEdit from '../../components/domains/DomainXpathEdit'
import { useGetDomainByIdQuery } from '../../redux/apis/domainsManagement/domains/dMDomainsApiSlice'
import Loader from '../pages/loader'
import { toast } from 'react-toastify'

const DomainInfoEditPage = () => {
  const { id, tab } = useParams()

  const { data, isLoading, error } = useGetDomainByIdQuery(
    {
      expand: ['domain_xpath', 'domain_category', 'language'].join(','),
      id: id
    },
    {
      skip: id == 0,
      refetchOnMountOrArgChange: true
    }
  )
  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  const context = useContext(AppSettings)
  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context]) // Add context as a dependency

  return (
    <div>
      <Loader isLoading={isLoading} />
      <div className='flex my-4 gap-2'>
        <Link
          type='button'
          className={`btn ${tab == 'info' ? 'btn-theme' : 'btn-default'}`}
          to={`/domains/domains-info/${id || 0}/info`}
        >
          Domain Info
        </Link>
        {id != 0 ? (
          <Link
            type='button'
            className={`btn ${tab == 'xpath' ? 'btn-theme' : 'btn-default'}`}
            to={`/domains/domains-info/${id || 0}/xpath`}
          >
            Domain xPath
          </Link>
        ) : null}
      </div>
      <div className='row'>
        <Card>
          {tab == 'info' && <DomainInfoEdit id={id} data={data} />}
          {tab == 'xpath' && (
            <DomainXpathEdit id={id} xpath={data?.data?.domain_xpath} />
          )}
        </Card>
      </div>
    </div>
  )
}

export default DomainInfoEditPage
